"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTransaction = void 0;
const invariant_1 = __importDefault(require("invariant"));
const gas_1 = require("./gas");
const gas_2 = require("./gas");
const logic_1 = require("./logic");
const transaction_1 = require("./transaction");
const modules_1 = require("./modules");
const account_1 = require("../../account");
const prepareTransaction = (account, tx) => __awaiter(void 0, void 0, void 0, function* () {
    const networkInfo = tx.networkInfo || (yield (0, gas_1.getNetworkInfo)(account.currency));
    if ((0, transaction_1.EIP1559ShouldBeUsed)(account.currency)) {
        const maxPriorityFeePerGas = (0, gas_1.inferMaxPriorityFeePerGas)(tx, networkInfo);
        const maxFeePerGas = (0, gas_1.inferMaxFeePerGas)(tx, maxPriorityFeePerGas, networkInfo);
        if (tx.maxFeePerGas !== maxFeePerGas ||
            tx.maxPriorityFeePerGas !== maxPriorityFeePerGas ||
            tx.networkInfo !== networkInfo) {
            tx = Object.assign(Object.assign({}, tx), { networkInfo: networkInfo, maxFeePerGas,
                maxPriorityFeePerGas });
        }
    }
    else {
        const gasPrice = (0, gas_1.inferGasPrice)(tx, networkInfo);
        if (tx.gasPrice !== gasPrice || tx.networkInfo !== networkInfo) {
            tx = Object.assign(Object.assign({}, tx), { networkInfo: networkInfo, gasPrice });
        }
    }
    let estimatedGasLimit;
    if ((0, logic_1.isEthereumAddress)(tx.recipient)) {
        // building a bear minimum transaction for gas estimation
        const protoTransaction = (() => {
            try {
                return (0, transaction_1.buildEthereumTx)(account, tx, account.operationsCount).tx;
            }
            catch (e) {
                // fallback in case @ethereumjs/tx breaks on building a potentially partial transaction
                const subAccount = tx.subAccountId ? (0, account_1.findSubAccountById)(account, tx.subAccountId) : null;
                const recipient = (subAccount === null || subAccount === void 0 ? void 0 : subAccount.type) === "TokenAccount" ? subAccount.token.contractAddress : tx.recipient;
                return {
                    from: account.freshAddress,
                    to: recipient,
                    data: undefined,
                    value: tx.amount,
                };
            }
        })();
        (0, invariant_1.default)(protoTransaction.to, "ethereum transaction has no recipient");
        estimatedGasLimit = yield (0, gas_2.estimateGasLimit)(account, 
        // Those are the only elements from a transaction necessary to estimate the gas limit
        {
            from: account.freshAddress,
            to: protoTransaction.to.toString(),
            value: "0x" + ((0, logic_1.padHexString)(protoTransaction.value.toString(16)) || "00"),
            data: protoTransaction.data
                ? `0x${(0, logic_1.padHexString)(protoTransaction.data.toString("hex"))}`
                : "0x",
        });
    }
    if (!tx.estimatedGasLimit || (estimatedGasLimit && !estimatedGasLimit.eq(tx.estimatedGasLimit))) {
        tx.estimatedGasLimit = estimatedGasLimit;
    }
    tx = yield (0, modules_1.prepareTransaction)(account, tx);
    return tx;
});
exports.prepareTransaction = prepareTransaction;
exports.default = exports.prepareTransaction;
//# sourceMappingURL=prepareTransaction.js.map